import React, {Component} from 'react'
import {Button, Modal, Header} from 'semantic-ui-react'

class DeleteConfirmModal extends Component{

    constructor(props) {
        super(props);
        this.state = {
            deleteInProgress: true,
            doneHandler: props.doneHandler,
            cancelHandler: props.cancelHandler,
            errorHandler: props.errorHandler,
            plaidItemId: props.plaidItemId,
            showSpinner: false,
            csrfToken: props.csrfToken
        }
    }

    deleteItem = () => {
        console.log("delete button pressed ");
        this.setState({showSpinner: true});
        fetch("/api/plaid/delete", {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': this.state.csrfToken
            },
            method: "POST",
            body: JSON.stringify({
                doAction: "remove",
                plaidItemId: this.state.plaidItemId
            })
        })
            .then(resp => resp.json())
            .then(resp => {
                console.log("removed account. Got response: "+JSON.stringify(resp));
                setTimeout(() => {
                    this.setState({
                        showSpinner: false,
                        deleteInProgress: false
                    });
                    this.state.doneHandler();
                }, 2000);

            })
            .catch(err => {
                // find a way to gently show the user that error happened!
                console.log("error obtained from /api/plaid/delete");
                alert("There was an error deleting the accounts.");
                setTimeout(() => {
                    this.setState({
                        showSpinner: false,
                        deleteInProgress: false
                    });
                    this.state.errorHandler();
                }, 2000);
            })

    }

    cancelled = () => {
        this.setState({deleteInProgress: false});
        this.state.cancelHandler();
    }


    render() {
        const noButton = <Button negative onClick={this.cancelled}>Cancel</Button>;
        const yesButton = this.state.showSpinner ?
            (
                <Button loading positive icon={"checkmark"} labelPosition={"right"} content={"Yes"} onClick={this.deleteItem}>
                </Button>

            ) : (
                <Button positive icon={"checkmark"} labelPosition={"right"} content={"Yes"} onClick={this.deleteItem}>
                </Button>
            );

        // deleteconfirm modal =====================================================

        const message = this.state.deleteInProgress ? "Deleting" : "Are you sure you would like to remove this group?";

        return (
            <Modal size={'mini'} open={this.state.deleteInProgress}>
                <Header icon='archive' content='Delete?'/>
                <Modal.Content>
                    <p>{message}</p>
                </Modal.Content>
                <Modal.Actions>
                    {noButton}
                    {yesButton}
                </Modal.Actions>
            </Modal>
        );
        // =======================================================================
    }
}
export default DeleteConfirmModal;